import {
  jb_gallery_css_default
} from "./chunk.DZKRCH3T.js";
import {
  jb_gallery_fullscreen_css_default
} from "./chunk.OY6IVQRB.js";
import {
  JbModal
} from "./chunk.NTO5HUBR.js";
import {
  disableBodyScroll,
  enableBodyScroll
} from "./chunk.A7Z76YXE.js";
import {
  EffectFade,
  Navigation,
  Pagination,
  core_default
} from "./chunk.WFUXQ5NL.js";
import {
  e as e2
} from "./chunk.3XLWIJBS.js";
import {
  reset_css_default
} from "./chunk.YAATWOBE.js";
import {
  isMobileVP,
  isTabletVP
} from "./chunk.YDQDJZUC.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  Spaceable
} from "./chunk.JI7MO3NT.js";
import {
  Animatable
} from "./chunk.V3FEQEPV.js";
import {
  debounce,
  recenterNavItems,
  respondTo
} from "./chunk.JTCOOS2A.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  e,
  n,
  r
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-gallery/jb-gallery.ts
core_default.use([Navigation, Pagination, EffectFade]);
var JbGallery = class extends Spaceable(i) {
  constructor() {
    super(...arguments);
    this.aspect = "16by9";
    this.initialSlide = 0;
    this.isFullscreen = false;
    this._isLoaded = false;
    this._nextDisabled = false;
    this._options = {
      contentWrappers: null,
      controlWrap: null,
      defaultScreen: null,
      fullScreen: null,
      images: null,
      imageWrappers: null,
      openButton: null,
      picturesCount: 0,
      picturesLoadedCount: 0,
      slider: null,
      swiper: null
    };
    this._prevDisabled = false;
  }
  firstUpdated() {
    this._init();
  }
  slideNext() {
    this._options.swiper.slideNext();
  }
  slidePrev() {
    this._options.swiper.slidePrev();
  }
  _bindEvents() {
    this._options.openButton?.addEventListener("click", async (e3) => {
      e3.preventDefault();
      const galleryFullscreen = new JbGalleryFullscreen().init({
        props: {
          gallery: this,
          currentSlide: this._options.swiper?.activeIndex,
          slot: "content",
          withSpacing: true
        }
      });
      galleryFullscreen.addEventListener("jb-gallery:slide-changed", (ev) => {
        this._options.swiper?.slideTo(ev.detail.currentSlide);
      });
      await customElements.whenDefined("jb-gallery-fullscreen").then(async () => {
        setTimeout(() => {
          galleryFullscreen.contentChildren = [galleryFullscreen.shadowRoot.querySelector("div")];
        }, 0);
      });
      const overlay = new JbModal().init({
        props: {
          color: "white",
          hasLogo: false,
          fullHeight: true,
          ariaLabels: { close: this.ariaLabels?.closeFullscreen }
        },
        childNodes: [galleryFullscreen]
      });
      overlay.addEventListener("jb-gallery-fullscreen:resized-too-small", async () => {
        await galleryFullscreen.hide();
        overlay.unstack();
        enableBodyScroll(this);
        recenterNavItems();
      });
      document.addEventListener("jb-modal:close", async () => {
        await galleryFullscreen.hide();
        overlay.unstack();
        enableBodyScroll(this);
        recenterNavItems();
      });
      overlay.stack();
      disableBodyScroll(this, { allowTouchMove: () => true });
      recenterNavItems();
      await galleryFullscreen.reveal();
    });
    if (this._options.controlWrap !== null) {
      this._setControlWrapPosition();
      window.addEventListener(
        "resize",
        debounce(() => {
          this._handleResize();
        }, 100)
      );
    }
  }
  _dom() {
    this._options.controlWrap = this.renderRoot.querySelector(".controls");
    this._options.imageWrappers = this.renderRoot.querySelectorAll(".image-wrapper");
    this._options.contentWrappers = this.renderRoot.querySelectorAll(".content");
    this._options.openButton = this.renderRoot.querySelector(".fullscreenbutton");
    this._options.defaultScreen = this.renderRoot.querySelector(".default-screen-placeholder");
    this._options.images = this.renderRoot.querySelectorAll("jb-picture");
    let pagination = {};
    let navigation = {};
    if (this.images?.length > 1) {
      pagination = {
        el: this.renderRoot.querySelector(".swiper-pagination"),
        type: "fraction",
        // @ts-ignore: Type expected number as return value
        formatFractionTotal: (num) => ("0" + num).slice(-2),
        // @ts-ignore: Type expected number as return value
        formatFractionCurrent: (num) => ("0" + num).slice(-2),
        renderFraction(currentClass, totalClass) {
          return `<span class="${currentClass}"></span><span class="swiper-pagination-separator">/</span><span class="${totalClass}"></span>`;
        }
      };
      navigation = {
        nextEl: this.renderRoot.querySelector("jb-arrow-navigation")?.shadowRoot?.querySelector("button:nth-of-type(2)"),
        prevEl: this.renderRoot.querySelector("jb-arrow-navigation")?.shadowRoot?.querySelector("button:nth-of-type(1)")
      };
    }
    const swiperOptions = {
      initialSlide: this.initialSlide,
      slidesPerView: 1,
      centeredSlides: true,
      spaceBetween: 40,
      effect: "fade",
      fadeEffect: {
        crossFade: true
      },
      on: {
        slideChange: (swiper) => {
          this.dispatchEvent(
            new CustomEvent("jb-gallery:slide-changed", {
              bubbles: true,
              composed: true,
              detail: {
                currentSlide: swiper.activeIndex
              }
            })
          );
          this._prevDisabled = swiper.isBeginning;
          this._nextDisabled = swiper.isEnd;
          if (swiper.isBeginning) {
            this._arrowNavigation?.shadowRoot?.querySelector("button:nth-of-type(2)")?.focus();
            this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
          }
          if (swiper.isEnd) {
            this._arrowNavigation?.shadowRoot?.querySelector("button:nth-of-type(1)")?.focus();
            this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
          }
        },
        init: (swiper) => {
          this._isLoaded = true;
          this._prevDisabled = swiper.isBeginning;
          this._nextDisabled = swiper.isEnd;
        }
      },
      pagination,
      navigation
    };
    this._options.slider = this.renderRoot.querySelector(".swiper-container");
    this._options.swiper = new core_default(this._options.slider, swiperOptions);
  }
  _getContentSpacingProperties() {
    return { colsMdUp: 8, type: "media", horizontal: "full-width-sm-down", grid: true };
  }
  _handleResize() {
    this._setControlWrapPosition();
  }
  _init() {
    const pictures = this.renderRoot.querySelectorAll("jb-picture");
    this._options.picturesCount = pictures.length;
    pictures.forEach(() => {
      this._options.picturesLoadedCount += 1;
    });
    const picturesInterval = setInterval(() => {
      if (this._options.picturesCount <= this._options.picturesLoadedCount) {
        clearInterval(picturesInterval);
        this._dom();
        this._bindEvents();
      }
    }, 100);
  }
  _renderImages() {
    return this.images.map(
      (img) => b`
        <div class="slide swiper-slide">
          <div class="image-wrapper aspect-${this.aspect}">
            <jb-picture
              .alt=${img.picture.alt}
              .imgData=${img.picture.imgData}
              .lazy=${img.picture.lazy}
              .fit=${"contain"}
            ></jb-picture>
          </div>
          <div class="content">
            ${img.caption ? b`<jb-heading class="content-title">${img.caption}</jb-heading>` : A}
            <p class="content-text">${img.text}</p>
            <span class="content-credit">${img.credit}</span>
          </div>
        </div>
      `
    );
  }
  _setControlWrapPosition() {
    if (this._options.controlWrap && this._options.imageWrappers) {
      this._options.controlWrap.style.setProperty("top", this._options.imageWrappers[0].offsetHeight + 16 + "px");
    }
  }
  render() {
    return this.images?.length ? b`
          <div
            class=${e2({ gallery: true, fullscreen: !!this.isFullscreen })}
            @keyup=${(evt) => {
      switch (evt.code) {
        case "ArrowLeft":
          evt.preventDefault();
          this.slidePrev();
          evt.stopPropagation();
          break;
        case "ArrowRight":
          evt.preventDefault();
          this.slideNext();
          evt.stopPropagation();
          break;
        default:
          break;
      }
    }}
          >
            <div class="swiper ${e2({ "is-loaded": this._isLoaded })}">
              <div class="swiper-container">
                ${!this.isFullscreen ? b`<button
                        class="fullscreenbutton"
                        aria-label="${this.ariaLabels?.openFullscreen ?? A}"
                      >
                        <jb-icon
                          iconName="fullscreen"
                          .size=${respondTo({ xs: "24", lg: "32" })}
                          commonAnimation="scale_increase"
                        ></jb-icon>
                      </button>` : A}
                <div class="swiper-wrapper">${this._renderImages()}</div>
                ${this.images?.length > 1 ? b` <div class="controls">
                        <div class="swiper-pagination pagination"></div>
                        <jb-arrow-navigation
                          .ariaLabels=${{
      prev: this.ariaLabels?.prev,
      next: this.ariaLabels?.next
    }}
                          .nextDisabled=${this._nextDisabled}
                          .prevDisabled=${this._prevDisabled}
                        ></jb-arrow-navigation>
                      </div>` : A}
              </div>
            </div>
          </div>
        ` : A;
  }
};
JbGallery.styles = [reset_css_default, jb_gallery_css_default];
JbGallery.shadowRootOptions = { ...i.shadowRootOptions, delegatesFocus: true };
__decorateClass([
  n({ type: Object })
], JbGallery.prototype, "ariaLabels", 2);
__decorateClass([
  n()
], JbGallery.prototype, "aspect", 2);
__decorateClass([
  n({ type: Array })
], JbGallery.prototype, "images", 2);
__decorateClass([
  n({ type: Number })
], JbGallery.prototype, "initialSlide", 2);
__decorateClass([
  n({ type: Boolean })
], JbGallery.prototype, "isFullscreen", 2);
__decorateClass([
  e("jb-arrow-navigation")
], JbGallery.prototype, "_arrowNavigation", 2);
__decorateClass([
  r()
], JbGallery.prototype, "_isLoaded", 2);
__decorateClass([
  r()
], JbGallery.prototype, "_nextDisabled", 2);
__decorateClass([
  r()
], JbGallery.prototype, "_prevDisabled", 2);
JbGallery = __decorateClass([
  customElement("jb-gallery")
], JbGallery);

// src/components/jb-gallery-fullscreen/jb-gallery-fullscreen.ts
var JbGalleryFullscreen = class extends Initiable(Animatable(i)) {
  constructor() {
    super(...arguments);
    this.currentSlide = 0;
  }
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener("keyup", this._handleKeyboardEvent);
  }
  disconnectedCallback() {
    document.removeEventListener("keyup", this._handleKeyboardEvent);
    super.disconnectedCallback();
  }
  firstUpdated() {
    window.addEventListener(
      "resize",
      debounce(() => {
        this._handleResize();
      }, 100)
    );
    document.addEventListener("jb-gallery:slide-changed", (e3) => {
      this.currentSlide = e3.detail.currentSlide;
    });
  }
  _handleKeyboardEvent(evt) {
    const galleryFullscreenNode = document.querySelector("jb-gallery-fullscreen");
    const galleryNode = galleryFullscreenNode.renderRoot.querySelector("jb-gallery");
    switch (evt.code) {
      case "ArrowLeft":
        evt.preventDefault();
        galleryNode.slidePrev();
        break;
      case "ArrowRight":
        evt.preventDefault();
        galleryNode.slideNext();
        break;
      default:
        break;
    }
  }
  _handleResize() {
    if (isMobileVP() || isTabletVP()) {
      this._resizedTooSmall();
    }
  }
  _resizedTooSmall() {
    this.dispatchEvent(
      new CustomEvent("jb-gallery-fullscreen:resized-too-small", {
        bubbles: true,
        composed: true
      })
    );
  }
  render() {
    return b`
      <div
        class=${e2({
      [`aspect-${this.gallery.aspect}`]: true
    })}
      >
        <jb-gallery
          .aspect=${this.gallery.aspect}
          .images=${this.gallery.images}
          .initialSlide=${this.currentSlide}
          isFullscreen
          .fit=${"contain"}
        ></jb-gallery>
      </div>
    `;
  }
};
JbGalleryFullscreen.styles = [reset_css_default, jb_gallery_fullscreen_css_default];
__decorateClass([
  n({ type: Number })
], JbGalleryFullscreen.prototype, "currentSlide", 2);
__decorateClass([
  n({ type: Object })
], JbGalleryFullscreen.prototype, "gallery", 2);
JbGalleryFullscreen = __decorateClass([
  customElement("jb-gallery-fullscreen")
], JbGalleryFullscreen);

export {
  JbGalleryFullscreen,
  JbGallery
};
